import React, {createContext, useState} from 'react';
import {Toast} from "../components/common/Toast";
import {getErrorMessage} from "../helpers/Utils";
import RestaurantOwnerService from "../services/RestaurantOwnerService";

export const RestaurantOwnerContext = createContext("RestaurantOwnerContext");

const RestaurantOwnerContextProvider = ({children}) => {

    const [restaurantOwnerList, setRestaurantOwnerList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);

    const getRestaurantOwnerList = async params => {
        try {
            setLoading(true);
            const response = await RestaurantOwnerService.getRestaurantOwnerList(params);
            setRestaurantOwnerList(response.data.content);
            setTotalElements(response.data.totalElements);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
        }

    }

    return (
        <RestaurantOwnerContext.Provider
            value={{
                loading,
                totalElements,
                restaurantOwnerList,
                getRestaurantOwnerList,
            }}
        >
            {children}
        </RestaurantOwnerContext.Provider>
    );
}

export default RestaurantOwnerContextProvider;
